// FAQ questions - answers referenced from problem statement content
export const FAQS = [
  { q: "Who can apply?", a: "Students, recent graduates, and young professionals from around the world may apply. Programs are also open to institutional groups." },
  { q: "Are the programs only for students?", a: "No. Programs are designed primarily for students but also welcome young professionals and institutional groups." },
  { q: "Can recent graduates apply?", a: "Yes. Recent graduates and early-career professionals are welcome to apply." },
  { q: "How long are the programs?", a: "Programs range from 7 to 21 days. Customized durations are available for group programs." },
  { q: "Do participants receive a certificate?", a: "Yes. All participants receive a StudyTrip Global Certificate of Completion." },
  { q: "Is accommodation included?", a: "Shared accommodation is included in most packages. Details are provided in each package." },
  { q: "Are meals included?", a: "Meals may or may not be included depending on the package. Confirm details in your formal quotation." },
  { q: "Is airfare included?", a: "International airfare is generally not included unless specifically stated in the package." },
  { q: "Are visa fees included?", a: "Visa fees are the responsibility of the participant and are not included in program pricing." },
  { q: "Does StudyTrip Global guarantee visa approval?", a: "No. Visa, travel, and entry decisions are made solely by the relevant government authorities." },
  { q: "Does the program include employment?", a: "No. Programs do not include employment, paid work, or productive workplace duties." },
  { q: "Is this an internship?", a: "No. These are short-term learning, cultural, and professional-development experiences, not internships." },
  { q: "Can participants work during the program?", a: "No. Participants may not undertake any unauthorized work during the program." },
  { q: "Can institutions send groups?", a: "Yes. Colleges, universities, and training centres can send groups with customized programs." },
  { q: "Can programs be customized?", a: "Yes. We create customized group programs for schools, colleges, universities, businesses, and training organizations." },
  { q: "Are payment plans available?", a: "Payment options may vary. Discuss available plans during the formal quotation process." },
  { q: "What happens if a visa is refused?", a: "Visa refusal handling and any refund policy will be outlined in your formal quotation and program terms." },
  { q: "Can parents receive program information?", a: "Yes. Parents and guardians may request program details on behalf of participants." },
  { q: "Is travel insurance required?", a: "Yes. Participants are responsible for arranging adequate medical and travel insurance." },
  { q: "Which countries are available?", a: "Currently Canada, Malaysia, Indonesia, and India. Additional destinations are coming soon." },
  { q: "Can participants choose more than one destination?", a: "Multi-destination itineraries can be discussed for customized group programs." },
  { q: "Are airport transfers included?", a: "Airport transfers are included in select packages. Check the package details." },
  { q: "What documents are required?", a: "A valid passport and any documents required by the destination country's visa authority." },
  { q: "Are prices fixed?", a: "Starting prices are estimates. A formal quotation with final pricing is provided before registration." },
  { q: "How early should students apply?", a: "We recommend applying at least 8-12 weeks before your preferred travel month." },
];

// Highlight chips on the homepage
export const HIGHLIGHTS = [
  "Short-Term Programs",
  "Affordable Packages",
  "International Exposure",
  "Educational Visits",
  "Cultural Experiences",
  "Certificate of Completion",
];

// Why StudyTrip Global — benefit tiles
export const BENEFITS = [
  { title: "Global perspective", icon: "Globe" },
  { title: "International confidence", icon: "Sparkles" },
  { title: "Cross-cultural communication", icon: "MessageCircle" },
  { title: "Professional development", icon: "Briefcase" },
  { title: "International networking", icon: "Users" },
  { title: "Leadership skills", icon: "Award" },
  { title: "Personal independence", icon: "Compass" },
  { title: "Career awareness", icon: "GraduationCap" },
  { title: "Exposure to international business", icon: "Building2" },
  { title: "Improved communication skills", icon: "Mic" },
  { title: "New cultural experiences", icon: "MapPin" },
  { title: "Stronger future profile", icon: "Star" },
];

// Journey steps for How It Works
export const JOURNEY_STEPS = [
  { title: "Choose Your Destination", desc: "Select Canada, Malaysia, Indonesia, India, or another available destination." },
  { title: "Choose Your Program", desc: "Select a course or request a customized learning experience." },
  { title: "Submit Your Application", desc: "Complete the online form with your personal, educational, and travel details." },
  { title: "Eligibility Review", desc: "Our team reviews your program suitability, travel plans, and available package options." },
  { title: "Receive Your Offer", desc: "Approved participants receive a program offer, payment details, schedule, and documents." },
  { title: "Arrange Travel Authorization", desc: "Participants independently apply for the required visa or travel permission." },
  { title: "Confirm Travel & Accommodation", desc: "Travel plans, accommodation, arrival details, and transportation are finalized." },
  { title: "Travel and Learn", desc: "Attend workshops, educational visits, cultural activities, and networking sessions." },
  { title: "Complete the Program", desc: "Participate in final activities and receive a Certificate of Completion." },
  { title: "Return With Global Experience", desc: "Use the knowledge, confidence, and connections gained during the program." },
];

export const STUDENT_JOURNEY = [
  "Home Country",
  "Application",
  "Program Acceptance",
  "Travel Preparation",
  "Flight",
  "Arrival",
  "Learning",
  "Company Visits",
  "Cultural Experience",
  "Certificate",
  "Return Home",
];

export const PARTNER_TARGETS = [
  "Colleges", "Universities", "Schools", "Training centres", "Education consultants",
  "Youth organizations", "Employers", "Chambers of commerce",
  "Professional associations", "Government and private institutions",
];

export const PARTNER_BENEFITS = [
  "International student programs",
  "Customized group packages",
  "Co-branded learning experiences",
  "Student recruitment support",
  "Destination coordination",
  "Educational visits",
  "International exposure",
  "Certificate programs",
  "Group discounts",
  "Long-term collaboration opportunities",
];

// Representative sample testimonials until verified student stories are collected.
// A subtle footnote is displayed in the UI to remain honest per the disclaimer.
export const TESTIMONIALS = [
  {
    id: "aisha-bd-my",
    name: "Aisha Rahman",
    initials: "AR",
    country: "Dhaka, Bangladesh",
    route: "Bangladesh → Malaysia",
    program: "Malaysia Discovery Program",
    quote:
      "The workshops in Kuala Lumpur were completely different from my usual classroom. Visiting a tech company, presenting our group project, and exploring Batu Caves in the same week gave me a whole new perspective.",
    accent: "red",
  },
  {
    id: "rohan-in-ca",
    name: "Rohan Verma",
    initials: "RV",
    country: "Mumbai, India",
    route: "India → Canada",
    program: "Canada Global Skills Program",
    quote:
      "Two weeks in Toronto covered so much — leadership sessions, a startup visit, a group project, and even a walk along the harbour. The certificate ceremony was the best moment.",
    accent: "amber",
  },
  {
    id: "fatima-ae-ca",
    name: "Fatima Al-Zahra",
    initials: "FA",
    country: "Dubai, UAE",
    route: "UAE → Canada",
    program: "Canada Explorer Program",
    quote:
      "I met students from four different countries in one classroom. The professional-communication workshop pushed me out of my comfort zone and I came home more confident.",
    accent: "teal",
  },
  {
    id: "kwame-gh-my",
    name: "Kwame Mensah",
    initials: "KM",
    country: "Accra, Ghana",
    route: "Ghana → Malaysia",
    program: "Malaysia Global Experience",
    quote:
      "The industry-exposure visits were the highlight. Seeing how a Malaysian logistics company runs day-to-day gave me ideas I plan to apply back home.",
    accent: "emerald",
  },
  {
    id: "nadia-id-in",
    name: "Nadia Sari",
    initials: "NS",
    country: "Jakarta, Indonesia",
    route: "Indonesia → India",
    program: "India Innovation Program",
    quote:
      "Ten days in Bangalore's startup community changed how I think about entrepreneurship. The mentors were incredibly generous with their time.",
    accent: "red",
  },
  {
    id: "wei-vn-id",
    name: "Wei-Ling Chen",
    initials: "WC",
    country: "Ho Chi Minh City, Vietnam",
    route: "Vietnam → Indonesia",
    program: "Indonesia Learning & Culture Program",
    quote:
      "Bali workshops on sustainable business, a batik afternoon, and a coffee-plantation visit — every day was different. Made friends I still message every week.",
    accent: "amber",
  },
];

// Globe arc routes (from → to) as [lat, lng]
export const GLOBE_ROUTES = [
  { from: "Malaysia (KL)", to: "Canada (Toronto)", start: [3.139, 101.6869], end: [43.6532, -79.3832], color: "#3B82F6" },
  { from: "India (Mumbai)", to: "Canada (Toronto)", start: [19.076, 72.8777], end: [43.6532, -79.3832], color: "#A855F7" },
  { from: "Indonesia (Jakarta)", to: "Canada (Vancouver)", start: [-6.2088, 106.8456], end: [49.2827, -123.1207], color: "#14B8A6" },
  { from: "India → Malaysia", to: "Kuala Lumpur", start: [28.7041, 77.1025], end: [3.139, 101.6869], color: "#F97316" },
  { from: "Bangladesh → Malaysia", to: "Kuala Lumpur", start: [23.685, 90.3563], end: [3.139, 101.6869], color: "#F59E0B" },
  { from: "Middle East → Canada", to: "Toronto", start: [25.2048, 55.2708], end: [43.6532, -79.3832], color: "#0EA5E9" },
  { from: "Africa → Malaysia", to: "KL", start: [6.5244, 3.3792], end: [3.139, 101.6869], color: "#EF4444" },
  { from: "Southeast Asia → Indonesia", to: "Jakarta", start: [13.7563, 100.5018], end: [-6.2088, 106.8456], color: "#22C55E" },
];
